export default "__VITE_ASSET__CxTBF2q___"